export default "/assets/images/dark-moss-sm.webp?1bb7c67b6e94f4bf9854b5992163895e";